import { Uuid } from '@manigo/manigo-domain-typings';

import { HttpService } from 'services/http';


export const getKybAccessTokenAPI = (companyExtUuid: Uuid) => HttpService.get(`/v2/kyb/${companyExtUuid}/access-token`);
export const getKycAccessTokenAPI = (queryParams: object) => HttpService.get('/v2/kyc/members/access-token', queryParams);
